module.exports = __webpack_public_path__ + "img/loading.ac4a764.gif";